import { Link } from "react-router-dom";
import { Linkedin, Twitter, Mail, Globe } from "lucide-react";
import BrandText from "../BrandText";

export default function Footer() {
  return (
    <footer className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-900" data-testid="footer-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-white rounded-xl p-2 shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_cc74fbba-7d42-4e61-a0ea-eedd771fa683/artifacts/7xq5yifk_ResHubNEW1.1-removebg-preview.png"
                  alt="ResiliencyHUB Logo"
                  className="h-[64px] w-auto block"
                />
              </div>
              <div>
                <BrandText size="md" className="text-white block leading-tight" />
                <p className="text-[11px] text-slate-300 mt-0.5 leading-tight">AI-Powered Resiliency Management Service</p>
              </div>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-[0.15em] mb-4">Product</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Features</a></li>
              <li><Link to="/request-demo" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Request Enquiry &amp; Demo</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-[0.15em] mb-4">Company</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">About</a></li>
              <li><Link to="/request-demo" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Contact</Link></li>
              <li><a href="#" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Blog</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-[0.15em] mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Privacy</a></li>
              <li><a href="#" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Terms</a></li>
              <li><a href="#" className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-300">Security</a></li>
            </ul>
          </div>
        </div>

        {/* Social + Bottom bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-sm text-slate-500">
            &copy; 2026 ResiliencyHUB · AI-Powered Resiliency Management Service. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
               className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
               aria-label="LinkedIn" data-testid="footer-linkedin">
              <Linkedin className="w-4 h-4 text-white" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
               className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
               aria-label="Twitter" data-testid="footer-twitter">
              <Twitter className="w-4 h-4 text-white" />
            </a>
            <a href="mailto:contact@resiliencyhub.ai"
               className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
               aria-label="Email" data-testid="footer-email">
              <Mail className="w-4 h-4 text-white" />
            </a>
            <a href="https://resiliencyhub.ai" target="_blank" rel="noopener noreferrer"
               className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-sky-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
               aria-label="Website" data-testid="footer-website">
              <Globe className="w-4 h-4 text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
